/**
 * 功能可见性权限（feature visibility）：控制「侧边栏快捷入口 + 积分/通知展示 + 接口调用」。
 * 与菜单权限（menuPermission）同属 userInfo.permissions 体系，不另起一套。
 */
export const PERMISSIONS = {
  /** 积分入口 / 余额 / 预计消耗 / 积分明细 / 充值 */
  POINTS_VIEW: "points.view",
  /** 通知入口 / 未读红点 / 通知列表弹窗 */
  NOTIFICATION_VIEW: "notification.view",
  /** 使用指南入口 */
  GUIDE_VIEW: "guide.view",
  /** 头像菜单「个人资料」按钮 → 打开 ProfileModal */
  USER_PROFILE: "user.profile",
  /** 头像菜单「API 密钥」按钮 → 打开 ApiKeyModal */
  API_KEY_LIST: "api.key.list",
} as const;

export type PermissionKey = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
